import React, { useEffect } from "react";
import { useState } from "react";
import "./FormNewPassword.css";
import Input from "../../../components/Input/Input";
import UserService from "../../../services/UserService";
import { useNavigate, useParams } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import Loader from "../../../components/Loader/Loader";
import Button from "../../../components/Button/Button";
import Logo from "../../../components/Logo/Logo";
import { useAuth } from "../../../contexts/auth";
import { SESSION_STORE, useIndexedDb } from "../../../contexts/indexedDb";

function FormNewPassword() {
	const [newPassword, setNewPassword] = useState("");
	const [confirmNewPassword, setConfirmNewPassword] = useState("");
	const [showLoader, setShowLoader] = useState(false);
	const navigate = useNavigate();
	const params = useParams();
	const { user } = useAuth();
	const { save: saveInCache, saveImage, lastSessionData } = useIndexedDb();

	useEffect(() => {
		async function getRecoveryPasswordData() {
			const response = await UserService.getRecoveryPasswordData(params.userId, params.token);
			if (response?.data) {
				if (response.data.defaultTheme)
					saveInCache({
						id: SESSION_STORE,
						theme: response.data.defaultTheme,
					}, SESSION_STORE);
				if (response.data.organizationUrlLogo)
					saveImage('organization-logo', response.data.organizationUrlLogo);
			}
		}
		getRecoveryPasswordData();
	}, [])

	function handleClickCancel() {
		if (user?.userData) {
			navigate('../')
		} else {
			navigate('../login');
		}
	}

	async function handleSubmit(event) {
		event.preventDefault();
		if (newPassword !== confirmNewPassword) {
			NotificationManager.error("", "Senhas não são iguais", 5000, () => {
				alert("callback");
			});
			return;
		}
		setShowLoader(true);
		let token = params.token;
		let id = params.userId;
		let organizationId = params.organizationId;

		await UserService.defineNewPassword(id, token, newPassword);
		setShowLoader(false);
		navigate("../login", { replace: true });
	}

	return (
		<div className="login-container">
			{showLoader ? (
				<Loader />
			) : (
				<React.Fragment>
					<form
						onSubmit={handleSubmit}
						className={`form-inputs-container login-form-container`}
					>
						<div className="form-new-password-inputs-container paper-background">
							<div className="login-logo-container">
								<Logo
									isLogin={true}
									alt="logo"
								/>
							</div>
							<h1 className="page-title">Redefinição de Senha</h1>
							<Input
								name={"senha"}
								id="senha"
								labelText={"Nova Senha"}
								value={newPassword}
								onChange={({ target }) => setNewPassword(target.value)}
								required={true}
								type="password"
							></Input>
							<Input
								name={"confirmar_senha"}
								id="confirmar_senha"
								labelText={"Confirmar nova senha"}
								value={confirmNewPassword}
								onChange={({ target }) => setConfirmNewPassword(target.value)}
								required={true}
								type="password"
							></Input>
							<div className="form-buttons">
								<Button
									className={"button-blue"}
									label={"Salvar"}
									type={"submit"}
								/>
								<Button
									className={"button-white"}
									label={"Cancelar"}
									onClick={handleClickCancel}
								/>
							</div>
						</div>
					</form>
				</React.Fragment>
			)}
		</div>
	);
}

export default FormNewPassword;
